import { unref as s, isRef as a, toRefs as i, customRef as p, getCurrentScope as c, onScopeDispose as f } from "vue";
function g(e) {
  return c() ? (f(e), !0) : !1;
}
function y(e) {
  return typeof e == "function" ? e() : s(e);
}
const S = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const v = Object.prototype.toString, m = (e) => v.call(e) === "[object Object]", A = () => {
};
function h(e, l = {}) {
  if (!a(e))
    return i(e);
  const o = Array.isArray(e.value) ? Array.from({ length: e.value.length }) : {};
  for (const t in e.value)
    o[t] = p(() => ({
      get() {
        return e.value[t];
      },
      set(r) {
        var u;
        if ((u = y(l.replaceRef)) != null ? u : !0)
          if (Array.isArray(e.value)) {
            const n = [...e.value];
            n[t] = r, e.value = n;
          } else {
            const n = { ...e.value, [t]: r };
            Object.setPrototypeOf(n, Object.getPrototypeOf(e.value)), e.value = n;
          }
        else
          e.value[t] = r;
      }
    }));
  return o;
}
export {
  S as isClient,
  m as isObject,
  A as noop,
  h as toRefs,
  y as toValue,
  g as tryOnScopeDispose
};
